import axios from '@/api/axios'

const deleteParent = (parentId, childId) => {
  return axios.delete(`/parents/${parentId}/deleteChildren?athlete=${childId}`)
}

export default {
  deleteParent,
}
